export const OVERNIGHT_CAMP_BRANCH_DETAILS_SUCCESS =
  'OVERNIGHT_CAMP_BRANCH_DETAILS_SUCCESS';
export const OVERNIGHT_CAMP_BRANCH_DETAILS_FAILURE =
  'OVERNIGHT_CAMP_BRANCH_DETAILS_FAILURE';
